export const IMAGE_PROVIDER_OPTIONS = [
  { value: "dalle", label: "OpenAI (GPT-5.5 Imagem)" },
  { value: "gemini", label: "Gemini Imagen (Google)" },
  { value: "nano-banana", label: "Nano Banana 2 (Gemini)" },
  { value: "heygen", label: "HeyGen (Marketing)" },
  { value: "glm-image", label: "GLM-Image (Zhipu AI)" },
  { value: "stability", label: "Stability AI (SD 3.5)" },
] as const;

export function imageProviderHint(provider: string): string {
  switch (provider) {
    case "dalle":
      return "OpenAI (GPT-5.5): geração de imagens de alta qualidade";
    case "gemini":
      return "Gemini Imagen: geração de imagens com IA do Google";
    case "nano-banana":
      return "Nano Banana 2: modelo Gemini para imagens (Google)";
    case "heygen":
      return "HeyGen: especializado em criativos de marketing";
    case "glm-image":
      return "GLM-Image: modelo de geração da Zhipu AI";
    case "stability":
      return "Stability AI: Stable Diffusion 3.5 Large";
    default:
      return "";
  }
}
